import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { ImportExportStats, Statistic, StatisticPerimeter } from 'src/app/core/_models/statistics';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/core/_services/auth.service';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';
import { SpinnerOverlayService } from 'src/app/core/_services/spinner.overlay.service';
import { StatisticService } from 'src/app/core/_services/statistic.service';

@Component({
  selector: 'app-statistic',
  templateUrl: './statistic.component.html',
  styleUrls: ['./statistic.component.scss']
})
export class StatisticComponent implements OnInit {
  statGenerale!: Statistic;
  statAdherents!: any;
  statuserACD!: any;
  statAdherentsColumns: string[] = ['nomAdherents', 'adherentStatus', 'totalLogins', 'totalAdherents', 'totalACD', 'totalACEU', 'totalAI', 'totalABE', 'totalCI', 'totalBE', 'totalProjet', 'totalCentrale', 'totalPDF'];
  statAdherentsColumnsACD: string[] = ['nomEU', 'totalLogins', 'totalAdherents', 'totalACD', 'totalACEU', 'totalAI', 'totalABE', 'totalCI', 'totalBE', 'totalProjet', 'totalCentrale', 'totalPDF'];
  statUserACDColumns: string[] = ['userName', 'userFirstName', 'email', 'profilCode'];
  startDate!: Date;
  endDate!: Date;
  startDateCEU!: Date;
  endDateCEU!: Date;
  startDateAdherent!: Date;
  endDateAdherent!: Date;
  profileCode!: string;
  perimeters: StatisticPerimeter[] = [];
  selectedPerimeterIds: string[] = [];
  importExportStats!: ImportExportStats;

  constructor(
    private statisticService: StatisticService,
    private spinnerService: SpinnerOverlayService,
    private datePipe: DatePipe,
    private authService: AuthService,
    private snackbarService: SnackbarService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.spinnerService.show();
    this.profileCode = this.profileCode = this.authService.roleValue?.profileCode;
    this.statisticService.getStatAdherents().subscribe(
      (data) => {
        this.statAdherents = data;

        this.statisticService.getAll().subscribe((stat) => {
          this.statGenerale = stat;
          if (this.profileCode == 'ACD') {
            this.statisticService.GetuserForAcdStatistics().subscribe((UserACDStat) => {
              this.statuserACD = UserACDStat;
            });
          }

          this.spinnerService.hide();
        });
      },
      (error) => {
        this.snackbarService.open(SnackbarTypes.error);
        this.spinnerService.hide();
      },
      () => {
        this.spinnerService.hide();
      }
    );
    this.statisticService.getSolutionsPerimeters().subscribe((perimeters) => {
      this.perimeters = perimeters;
    });
    this.statisticService.getImportExportStats().subscribe((data) => {
      this.importExportStats = data;
      this.statisticService.getImportExportStats().subscribe(
        (data) => {
          this.importExportStats = data;
        },
        (error) => {
          this.snackbarService.open(SnackbarTypes.error);
        }
      );
    });
  }

  exportExcel() {}

  exportAdherents() {
    this.spinnerService.show();
    return this.statisticService.getAdherentsStatsExportExcel(this.datePipe.transform(this.startDateAdherent, 'yyyy-MM-dd'), this.datePipe.transform(this.endDateAdherent, 'yyyy-MM-dd')).subscribe(
      (data) => {
        this.spinnerService.hide();
        this.downloadFile(data, 'Adherents.xlsx');
      },
      (error) => {
        this.snackbarService.open(SnackbarTypes.error);
        this.spinnerService.hide();
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  exportStatExcel() {
    this.spinnerService.show();
    return this.statisticService.getStatsExportExcel().subscribe(
      (data) => {
        this.spinnerService.hide();
        this.downloadFile(data, 'DonneeSEVE.xlsx');
      },
      (error) => {
        this.snackbarService.open(SnackbarTypes.error);
        this.spinnerService.hide();
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  exportUsageExcel() {
    this.spinnerService.show();
    return this.statisticService.getUsagesExport(this.datePipe.transform(this.startDate, 'yyyy-MM-dd'), this.datePipe.transform(this.endDate, 'yyyy-MM-dd')).subscribe(
      (data) => {
        this.spinnerService.hide();
        this.downloadFile(data, 'Usages.xlsx');
      },
      (error) => {
        this.snackbarService.open(SnackbarTypes.error);
        this.spinnerService.hide();
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  exportSolutionsUsageExcel() {
    this.spinnerService.show();
    if (this.startDateCEU != undefined && this.endDateCEU != undefined) {
      return this.statisticService.getSolutionsUsagesExport(this.datePipe.transform(this.startDateCEU, 'yyyy-MM-dd'), this.datePipe.transform(this.endDateCEU, 'yyyy-MM-dd'), this.selectedPerimeterIds).subscribe(
        (data) => {
          this.spinnerService.hide();
          this.downloadFile(data, 'exportsolutionseve.xlsx');
        },
        (error) => {
          this.snackbarService.open(SnackbarTypes.error);
          this.spinnerService.hide();
        },
        () => {
          this.spinnerService.hide();
        }
      );
    } else {
      this.spinnerService.hide();
      this.snackbarService.showMessage(this.translate.instant('error_must_select_date'));
    }
  }

  downloadFile(data: Blob, fileName: string) {
    const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const blob = new Blob([data], { type: contentType });
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.setAttribute('download', fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
}
